module.exports = __webpack_public_path__ + "media/images/icon-event@3x-59f0c6fa4830ab7551d1b0bf8d3f9ca3.png";